import api from "./api";

const auditLogService = {
  getAuditLogs: (params) => api.get("/audit-logs", { params }),
  getAuditLogById: (id) => api.get(`/audit-logs/${id}`),
};

export default auditLogService;
